import { PARTNER_LOGOS } from "@/constants/siteData";

export default function PartnerMarquee({ label = "Trusted by leaders across industries" }) {
  const logos = [...PARTNER_LOGOS, ...PARTNER_LOGOS];
  return (
    <section
      data-testid="partners-marquee"
      className="border-y border-[#e5e7eb] bg-[#f9fafb] py-14"
    >
      <div className="container-page mb-8 flex items-center justify-between gap-4 flex-wrap">
        <p className="eyebrow">{label}</p>
        <p className="font-mono text-xs text-[#4B5563]">
          Partial listing of customers & partners
        </p>
      </div>
      <div className="marquee">
        <div className="marquee-track">
          {logos.map((logo, i) => (
            <div
              key={`${logo.name}-${i}`}
              data-testid={`partner-logo-${i}`}
              className="flex items-center justify-center h-14 min-w-[140px]"
            >
              <img
                src={logo.src}
                alt={logo.name}
                loading="lazy"
                className="max-h-12 w-auto object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
